import { Authenticator } from "@aws-amplify/ui-react";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import "./assets/index.css";
import App from "./App";
import store from "./store";

// ローカル実行環境でのみResizeObserverエラーが発生
// 機能的な不具合ではなく、開発ツールとReactの相互作用による表示上の問題
// 本番環境（ビルド後）では発生しないため、エラーを無視する処理を追加
// ResizeObserverエラーを無視し、Webpack Dev Serverオーバーレイも削除
const suppressResizeObserverError = () => {
  // Webpack Dev Server エラーオーバーレイを削除
  const errorOverlay = document.getElementById('webpack-dev-server-client-overlay-div');
  const errorOverlayContent = document.getElementById('webpack-dev-server-client-overlay');

  if (errorOverlay) {
    errorOverlay.style.display = 'none';
    errorOverlay.remove();
  }
  if (errorOverlayContent) {
    errorOverlayContent.style.display = 'none';
    errorOverlayContent.remove();
  }

  // 定期的にチェックして削除
  setTimeout(() => {
    const overlay = document.querySelector('[id*="webpack-dev-server"]');
    if (overlay) {
      overlay.style.display = 'none';
      overlay.remove();
    }
  }, 100);
};

window.addEventListener('error', (e) => {
  if (e.message && (
    e.message.includes('ResizeObserver loop') ||
    e.message === 'ResizeObserver loop completed with undelivered notifications.'
  )) {
    e.preventDefault();
    e.stopImmediatePropagation();
    suppressResizeObserverError();
  }
});

// unhandledrejectionも対処
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver loop')) {
    e.preventDefault();
    suppressResizeObserverError();
  }
});

// DOMContentLoadedでも実行
document.addEventListener('DOMContentLoaded', () => {
  // 定期的にオーバーレイをチェックして削除
  const intervalId = setInterval(() => {
    const overlay = document.querySelector('[id*="webpack-dev-server"]');
    const errorDiv = document.querySelector('[data-reactroot]')?.nextSibling;

    if (overlay && overlay.textContent && overlay.textContent.includes('ResizeObserver')) {
      overlay.style.display = 'none';
      overlay.remove();
    }

    if (errorDiv && errorDiv.textContent && errorDiv.textContent.includes('ResizeObserver')) {
      errorDiv.style.display = 'none';
      errorDiv.remove();
    }
  }, 500);

  // 30秒後にインターバルを停止
  setTimeout(() => clearInterval(intervalId), 30000);
});

// React StrictModeとMaterial-UIのバージョン互換性の問題を回避するため、StrictModeをコメントアウト
// React.StrictModeは開発環境でのみ影響するため、デプロイ環境には影響しない
// Material-UIをアップデートするときにコメントアウトを解除する
ReactDOM.render(
  // <React.StrictMode>
  <Provider store={store}>
    <Authenticator.Provider>
      <App />
    </Authenticator.Provider>
  </Provider>,
  // </React.StrictMode>,
  document.getElementById("root")
);
